import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex justify-between p-y-16px" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = { style: {"float":"right"} }
const _hoisted_4 = { key: 0 }

import { Divider, Space } from 'ant-design-vue';
import TableSetting from '../table-settings/index.vue';
import BasicHelp from '@/components/basic/basic-help/index.vue';
import type { MenuProps } from 'ant-design-vue';
import { useTableContext } from '@/components/lt-a-table/src/hooks';
import { onMounted } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  title: {
    type: String,
    default: '',
  },
  titleTooltip: {
    type: String,
    default: '',
  },
  showTableSetting: {
    type: Boolean,
    default: true,
  },
  showOrderParama: {
    type: Boolean,
    default: false,
  },
  showFullScreen: {
    type: Boolean,
    default: false,
  },
  exportFileName: {
    type: String,
    default: '',
  },
  showAutoForm: {
    type: Boolean,
    default: true,
  },
  isExportCurrent: {
    type: Boolean,
    default: false,
  }
},
  emits: ['cols-change', 'order-change', "full-screen", "complex-query", "export-data"],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;
const handleColsChange = function (cols) {
  emit('cols-change', cols)
}

const handleOrderChange = function (form, union) {
  emit('order-change', form, union)
}
const handleFullScreen = function (value) {
  emit('full-screen', value)
}

const handlerComplexChange = function (val) {
  //复杂查询条件
  emit('complex-query', val)
}
const { exportData2Excel } = useTableContext();

const handleMenuClick: MenuProps['onClick'] = e => {
  if (e.key == '1') {
    exportData2Excel()
  } else {
    exportData2Excel('all')
  }
};

onMounted(() => {

})


return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_DownOutlined = _resolveComponent("DownOutlined")!
  const _component_a_dropdown_button = _resolveComponent("a-dropdown-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "headerTitle", {}, () => [
      _createElementVNode("div", _hoisted_2, [
        _createTextVNode(_toDisplayString(__props.title) + " ", 1),
        (__props.titleTooltip)
          ? (_openBlock(), _createBlock(BasicHelp, {
              key: 0,
              class: "ml-6px pt-3px",
              text: __props.titleTooltip
            }, null, 8, ["text"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_unref(Space), null, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "toolbar"),
          (__props.exportFileName)
            ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                _renderSlot(_ctx.$slots, "export-button", {}, () => [
                  (__props.isExportCurrent == true)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        size: "small",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(exportData2Excel)()))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('component.excel.export')), 1)
                        ]),
                        _: 1
                      }))
                    : (_openBlock(), _createBlock(_component_a_dropdown_button, {
                        key: 1,
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(exportData2Excel)())),
                        size: "small"
                      }, {
                        overlay: _withCtx(() => [
                          _createVNode(_component_a_menu, { onClick: handleMenuClick }, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_menu_item, { key: "1" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('component.excel.exportCurrent')), 1)
                                ]),
                                _: 1
                              }),
                              _createVNode(_component_a_menu_item, { key: "2" }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('component.excel.exportAll')), 1)
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        icon: _withCtx(() => [
                          _createVNode(_component_DownOutlined)
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('component.excel.export')) + " ", 1)
                        ]),
                        _: 1
                      }))
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 3
      }),
      (_ctx.$slots.toolbar && __props.showTableSetting)
        ? (_openBlock(), _createBlock(_unref(Divider), {
            key: 0,
            type: "vertical"
          }))
        : _createCommentVNode("", true),
      (__props.showTableSetting)
        ? (_openBlock(), _createBlock(TableSetting, {
            key: 1,
            showOrderParama: __props.showOrderParama,
            showFullScreen: __props.showFullScreen,
            showAutoForm: __props.showAutoForm,
            onClosChangeByTools: handleColsChange,
            onOrderChange: handleOrderChange,
            onFullScreen: handleFullScreen,
            onComplexQuery: handlerComplexChange
          }, null, 8, ["showOrderParama", "showFullScreen", "showAutoForm"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})